import { Table } from '#shared/components/UI';
import { SubAccountsListsShow } from './types';

type ClientAccountsCountProps = {
  subAccount: Pick<SubAccountsListsShow, 'ClientAccountsEnabled' | 'NumClientAccounts'>;
  /** Opens the Client Accounts drawer. */
  onOpen: () => void;
};

// The Client Accounts column: how many client accounts are linked to the row (ID-13661).
// "-" when the account doesn't have client accounts enabled; a non-zero count opens the drawer.
export default function ClientAccountsCount({ subAccount, onOpen }: ClientAccountsCountProps) {
  if (!subAccount.ClientAccountsEnabled) return '-';

  if (subAccount.NumClientAccounts === 0) return subAccount.NumClientAccounts;

  return <Table.LinkButton onClick={onOpen}>{subAccount.NumClientAccounts}</Table.LinkButton>;
}
